module.exports = __webpack_public_path__ + "img/android4icon3.78a8e020.png";